import { render, staticRenderFns } from "./BlackGoldLangModal.vue?vue&type=template&id=9024ac32"
import script from "./BlackGoldLangModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldLangModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports